module.exports = __webpack_public_path__ + "static/img/shezhi@2x.3e6f740.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/gallery/shezhi@2x.png
// module id = T7rp
// module chunks = 1